import BaseTextarea from './BaseTextarea.vue';

export { BaseTextarea };
